// ============================================================
// เอกสาร ใบแจ้งหนี้ตามห้อง  (/doc/invoice-by-room)
// ------------------------------------------------------------
// หน้านี้เปิดในแท็บใหม่จากหน้าจออื่น ๆ ผ่าน openDocument()
// ข้อมูลที่จะพิมพ์ถูกส่งมาทาง localStorage คีย์ "DATA_"
// รูปแบบเอกสาร (เปิด/ปิดแต่ละส่วน ข้อความหัว-ท้าย) มาจากหน้าตั้งค่าเอกสาร
// ============================================================

import React, { Component } from "react";
import { readStorageJSON, tokens, format_date, GET, getStorage, toFixed, replaceTextHTML, loading } from "../../shared/index.js";
import LOGO from "../../assets/images/logo.png";
import "../../assets/css/bootstrap.css";
import "../../assets/css/index.css";

const size = {
  "A4": { width: 1116, height: 789 },
  "A5": { width: 1116, height: 792, zoom: 0.5 },
  "4.5 x 5.5 นิ้ว": { width: 1116, height: 685, zoom: 0.385 },
  "9 x 11 นิ้ว": { width: 1116, height: 685, zoom: 0.77 },
  "9 x 5.5 นิ้ว": { width: 1116, height: 685, zoom: 0.77 },
};

export default class PaymentHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      setting: {
        size: "A4",
        header_1: { status: true, title: "-โลโก้" },
        header_2: { status: true, title: "" },
        header_3: { status: true, title: "" },
        header_4: { status: true, title: "-ใบแจ้งหนี้ค่าน้ำ/ค่าใช้จ่ายส่วนกลาง" },
        header_5: { status: true, title: "-เลขที่ใบแจ้งหนี้" },
        header_6: { status: true, title: "-วันที่แจ้งหนี้" },
        header_7: { status: true, title: "-ชื่อ-นามสกุล" },
        th_1: { status: true, title: "-เลขมาตร เดือนนี้" },
        th_2: { status: true, title: "-เลขมาตร เดือนก่อน" },
        th_3: { status: true, title: "-หน่วยที่ใช้" },
        th_4: { status: true, title: "-ค่าน้ำประปา" },
        th_5: { status: true, title: "-ค่าบริการอุปกรณ์" },
        th_6: { status: true, title: "-ค่าขยะ" },
        th_7: { status: true, title: "-ค่าส่วนกลาง" },
        th_8: { status: true, title: "-ค่าเบี้ยประกัน" },
        th_9: { status: true, title: "-ค่าเคเบิล" },
        th_10: { status: true, title: "-เพิ่ม/ลดหนี้" },
        th_11: { status: true, title: "-ค่าต่อมิเตอร์" },
        th_12: { status: true, title: "-เบี้ยปรับ" },
        th_13: { status: true, title: "-ค่าใช้จ่ายปัจจุบัน" },
        th_14: { status: true, title: "-งวดค้าง" },
        th_15: { status: true, title: "-จำนวนเงินค้างชำระ" },
        tr_1: { status: true, title: "-ข้อมูลในตาราง" },
        footer_1: { status: true, title: "-รวมเป็นเงิน" },
        footer_2: { status: true, title: "" },
        footer_3: { status: true, title: "" },
        footer_4: { status: true, title: "" },
        footer_5: { status: true, title: "" },
        footer_6: { status: true, title: "" },
        footer_7: { status: true, title: "" },
        footer_8: { status: true, title: "" },
        footer_9: { status: true, title: "" },
      },
    };
  }

  async componentDidMount() {
    loading(false); // เรียกใช้ปิด loading ทันทีตั้งแต่เข้ามา

    await this.Get();
    const localData = readStorageJSON("DATA_");
    if (localData) this.setState({ data: localData });

    // ให้รอ Render สักครู่ แล้วประมวลผลข้อความ / เปิดหน้าต่าง Print
    setTimeout(async () => {
      await replaceTextHTML();
      window.print();
    }, 1000);
  }

  Get = async () => {
    loading(true);
    let result = await GET(tokens, `v1/TH/document-manage/detail/custom-document/${getStorage("project_id")}`, null);
    if (result?.status && result.data?.data?.invoice_by_room) {
      this.setState({ setting: result.data.data.invoice_by_room });
    }
    loading(false);
  };

  render() {
    const { data, setting: s } = this.state;
    // Helper function ช่วยตรวจสอบว่าควรซ่อน element (d-none) หรือไม่
    const chk = (key) => (!s[key]?.status ? "d-none" : "");
    const hideHeaderTop = (!s.header_1?.status && !s.header_2?.status && !s.header_3?.status && !s.header_5?.status && !s.header_6?.status) ? "d-none" : "";

    return (
      <div className="w-100">
        {data.map((item, index) => {
          // คำนวณวันที่ไว้ล่วงหน้าเพื่อลดความซับซ้อนใน JSX และเพิ่มความเร็ว
          const d = new Date(item.datetime_create);
          const d1 = new Date(d.getFullYear(), d.getMonth(), 1);
          const d0 = new Date(d.getFullYear(), d.getMonth() - 1, 1);
          const d2 = new Date(d.getFullYear(), d.getMonth() + 1, 1);

          return (
            <div key={index} className={`mx-auto bg-white border-bottom ${s.size === "9 x 5.5 นิ้ว" ? "pdf-small" : "pdf"}`}
              style={{
                ...size[s.size || "A4"],
                paddingLeft: Number(s.paddingLeft || 0),
                paddingRight: Number(s.paddingRight || 0),
                paddingTop: Number(s.paddingTop || 0),
                paddingBottom: Number(s.paddingBottom || 0),
              }}>
              <table className="table table-bordered mb-0 header">
                <tbody>
                  <tr className={hideHeaderTop}>
                    <td rowSpan={2} className="border-bottom-0">
                      <div className="d-flex align-items-center">
                        <img src={getStorage("picture_paper") || LOGO} style={{ width: 100, height: 100, objectFit: "contain", marginRight: 6 }} alt="LOGO" className={`bg-contain ${chk('header_1')}`} />
                        <div>
                          <h2 className={`fw-bold px-2 mb-0 ${chk('header_2')}`}>{s.header_2?.title || ""}</h2>
                          <div className={`px-2 ${chk('header_3')}`}>
                            {s.header_3?.title?.split("\n").map((e, i) => <div key={i}>{e}</div>) || ""}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td className={`wpx-250 text-center border-bottom-0 ${chk('header_4')}`}>
                      <h4 className="fw-bold mb-0">ใบแจ้งหนี้ค่าน้ำ/ค่าใช้จ่ายส่วนกลาง</h4>
                    </td>
                  </tr>
                  <tr className={hideHeaderTop}>
                    <td className="border-bottom-0 wpx-250">
                      <div className={chk('header_5')}>เลขที่ใบแจ้งหนี้ : {`${format_date(d, "yymm")}-${item.address_number}`}</div>
                      <div className={chk('header_6')}>วันที่แจ้งหนี้ : {format_date(new Date(), "dd mmmm yyyy")}</div>
                    </td>
                  </tr>
                  <tr className={chk('header_7')}>
                    <td className="border-bottom-0" colSpan={2}>
                      <h4 className="fw-bold mb-0">ชื่อ-นามสกุล : {`${item.full_name} อาคารเลขที่ ${item.building} ห้องเลขที่ ${item.address || item.address_number}`}</h4>
                    </td>
                  </tr>
                </tbody>
              </table>

              <table className="table table-bordered mb-0">
                <thead>
                  <tr>
                    <td className={`py-1 text-center ${chk('th_1')}`}>เลขมาตร {format_date(d1, "mmm")}</td>
                    <td className={`py-1 text-center ${chk('th_2')}`}>เลขมาตร {format_date(d0, "mmm")}</td>
                    <td className={`py-1 text-center ${chk('th_3')}`}>หน่วยที่ใช้</td>
                    <td className={`py-1 text-center ${chk('th_4')}`}>ค่าน้ำประปา {format_date(d1, "mmm yy", "th")}</td>
                    <td className={`py-1 text-center ${chk('th_5')}`}>ค่าบริการอุปกรณ์ {format_date(d1, "mmm yy", "th")}</td>
                    <td className={`py-1 text-center ${chk('th_6')}`}>ค่าขยะ {format_date(d1, "mmm yy", "th")}</td>
                    <td className={`py-1 text-center ${chk('th_7')}`}>ค่าส่วนกลาง {format_date(d2, "mmm yy", "th")}</td>
                    <td className={`py-1 text-center ${chk('th_8')}`}>ค่าเบี้ยประกัน</td>
                    <td className={`py-1 text-center ${chk('th_9')}`}>ค่าเคเบิล</td>
                    <td className={`py-1 text-center ${chk('th_10')}`}>เพิ่ม/ลดหนี้</td>
                    <td className={`py-1 text-center ${chk('th_11')}`}>ค่าต่อมิเตอร์</td>
                    <td className={`py-1 text-center ${chk('th_12')}`}>เบี้ยปรับ</td>
                    <td className={`py-1 text-center ${chk('th_13')}`}>ค่าใช้จ่ายปัจจุบัน</td>
                    <td className={`py-1 text-center ${chk('th_14')}`}>งวดค้าง</td>
                    <td className={`py-1 text-center ${chk('th_15')}`}>จำนวนเงินค้างชำระ</td>
                  </tr>
                </thead>
                <tbody>
                  <tr className={chk('tr_1')}>
                    <td className={`py-1 text-center ${chk('th_1')}`}>{item.current_gauge_number}</td>
                    <td className={`py-1 text-center ${chk('th_2')}`}>{item.last_gauge_number}</td>
                    <td className={`py-1 text-center ${chk('th_3')}`}>{item.unit_used}</td>
                    <td className={`py-1 text-right ${chk('th_4')}`}>{toFixed(item.water_bill)}</td>
                    <td className={`py-1 text-right ${chk('th_5')}`}>{toFixed(item.equipment_maintenance_fee)}</td>
                    <td className={`py-1 text-right ${chk('th_6')}`}>{toFixed(item.waste_cost)}</td>
                    <td className={`py-1 text-right ${chk('th_7')}`}>{toFixed(item.common_expenses)}</td>
                    <td className={`py-1 text-right ${chk('th_8')}`}>{toFixed(item.fire_cost)}</td>
                    <td className={`py-1 text-right ${chk('th_9')}`}>{toFixed(item.cable_cost)}</td>
                    <td className={`py-1 text-right ${chk('th_10')}`}>{toFixed((item.add_debt || 0) - (item.reduce_debt || 0))}</td>
                    <td className={`py-1 text-right ${chk('th_11')}`}>{toFixed(item.meter_connect_cost_all ?? item.meter_connect_cost)}</td>
                    {/* แสดงยอดรวมเบี้ยปรับทุกงวด (display only ไม่ถูกนำไปรวมกับยอดใดๆ) */}
                    <td className={`py-1 text-right ${chk('th_12')}`}>{toFixed(item.late_payment_all ?? item.late_payment)}</td>
                    <td className={`py-1 text-center ${chk('th_13')}`}>{toFixed(item.total_amount || 0)}</td>
                    <td className={`py-1 text-right ${chk('th_14')}`}>{Math.max((item.count_installment || 1) - 1, 0)}</td>
                    <td className={`py-1 text-right ${chk('th_15')}`}>{toFixed(item.overdue_amount || 0)}</td>
                  </tr>
                </tbody>
              </table>

              <table className={`table table-bordered mb-0 ${chk('footer_2')}`}>
                <tbody>
                  <tr>
                    <td className="border-top-0 text-right">
                      <div className="d-flex justify-content-end">
                        <h3 className="fw-bold d-flex mb-0">
                          รวมทุกรายการเป็นเงินทั้งสิ้น {toFixed((item.total_amount || 0) + (item.overdue_amount || 0))} บาท
                        </h3>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="py-1 border-top-0 text-center">{s.footer_2?.title}</td>
                  </tr>
                </tbody>
              </table>

              <div className={`mb-5 mt-2 ${chk('footer_3')}`}>
                {s.footer_3?.title?.split("\n").map((e, i) => <div key={i}>{e}</div>) || ""}
              </div>

              <div className="d-flex w-100">
                <div className="w-100">
                  <div className={`fw-bold text-danger text-30 mb-4 ${chk('footer_4')}`}>{s.footer_4?.title}</div>
                  <div className={`fw-bold text-danger text-30 mb-4 ${chk('footer_5')}`}>{s.footer_5?.title}</div>
                  <div className={`fw-bold text-primary text-30 ${chk('footer_6')}`}>{s.footer_6?.title}</div>
                </div>
                <div className="wpx-350 text-center">
                  <div className="w-100 d-flex justify-content-center mb-3">
                    {s.footer_7?.title && <img src={`data:image/png;base64,${s.footer_7.title}`} style={{ width: 150, height: 150, objectFit: "contain", marginRight: 6 }} alt="QR Code" className={`bg-contain mx-2 ${chk('footer_7')}`} />}
                    {s.footer_8?.title && <img src={`data:image/png;base64,${s.footer_8.title}`} style={{ width: 150, height: 150, objectFit: "contain", marginRight: 6 }} alt="QR Code" className={`bg-contain mx-2 ${chk('footer_8')}`} />}
                  </div>
                  <div className={`text-center w-100 ${chk('footer_9')}`}>{s.footer_9?.title}</div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}